<template>
  <div class="order-list-item app-bg" :class="{nopay:order.status === 0}" v-if="order">
    <v-layout class="item-header" justify-space-between>
      <span class="time">{{ time }}</span>
      <span>{{ status }}</span>
    </v-layout>
    <v-layout class="item-content" justify-space-between>
      <v-flex>
        <table class="item-table">
          <tr>
            <td class="td-key">险种</td>
            <td class="td-value">{{ order.productName }}</td>
            <td class="td-key">
              <span v-if="order.status === 1">保单号</span>
            </td>
            <td class="td-value">
              <span v-if="order.status === 1">{{ order.policyNo }}</span>
            </td>
          </tr>
          <tr>
            <td class="td-key">企业名称</td>
            <td class="td-value">{{ order.applicantName }}</td>
            <td class="td-key">保费</td>
            <td class="td-value">￥{{ order.amounts }}</td>
          </tr>
        </table>
      </v-flex>
      <v-flex shrink>
        <v-layout align-center fill-height>
          <v-btn color="primary" class="item-btn" v-if="order.status === 0" @click="toPay">继续支付</v-btn>
          <v-btn color="primary" class="item-btn" @click="toDetail(order.orderCode,order.productId)">保单详情</v-btn>
          <!-- <v-btn :to="`/order/detail/${order.orderCode}`" class="item-btn" outline>保单详情</v-btn> -->
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    order: Object
  },
  data() {
    return {
      // order: {
      //   submitTime: "2019年1月16日 18:30",
      //   status: "已出单",
      //   seriesName: "诚泰团体意外伤害保险",
      //   policyNo: "2397511849258930",
      //   applicantName: "北京皇家测试公司",
      //   amounts: "￥2187.00"
      // }
    };
  },
  computed: {
    time() {
      if (this.order.submitTime) {
        return this.$miment(this.order.submitTime).format("YYYY年MM月DD日 hh:mm");
      }
      return "xxxx年xx月xx日 xx:xx";
    },
    status() {
      if (this.order.status === 1) {
        return "已出单";
      } else if (this.order.status === 0) {
        return "待支付";
      }
      return "未知";
    }
  },
  methods: {
    toDetail(orderCode,productId){
      this.$router.push({
        path:'/order/detail/'+orderCode,
        query:{
          productId:productId
        }
      });
    },
    toPay() {
      const orderCode = this.order.orderCode;
      this.$router.push({ name: "tkpay", params: { orderCode } });
    }
  }
};
</script>

<style lang="scss" scoped>
$nopay-color: #fb7282;
.order-list-item {
  margin-top: 20px;
  border: 1px solid #cccccc;
  font-size: 14px;
  &.nopay {
    border-color: $nopay-color;
    .item-header {
      background-color: #fffafb;
      border-bottom: 1px solid $nopay-color;
    }
  }
  .item-header {
    padding: 18px 30px;
    background-color: #fcfcfc;
    border-bottom: 1px solid #cccccc;
    .time {
      color: #666666;
    }
  }
  .item-content {
    padding: 14px 30px;
    .item-btn {
      border: 0.5px solid #979797;
      width: 110px;
      height: 34px;
    }
    .item-table {
      .td-key {
        color: $font-color3;
      }
      .td-value {
        padding: 2px 40px 2px 15px;
      }
    }
  }
}
</style>

